module.exports = __webpack_public_path__ + "static/img/蒙版组 309@2x.af38deef.png";